import { Box, Typography } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/icons/layout-icons/InfoAlertIcon.svg';

export const AiChatDisclaimer = ({ fontSize = '0.75rem' }: { fontSize?: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: '8px 12px',
        backgroundColor: 'rgba(255, 165, 0, 0.08)',
        border: '1px solid rgba(255, 165, 0, 0.2)',
      }}
    >
      <InfoIcon style={{ width: 16, height: 16, minWidth: 16, fill: '#ff9800' }} />
      <Typography variant="body3" fontSize={fontSize} color={'text.secondary'}>
        AI can make mistakes. Please verify important details.
      </Typography>
    </Box>
  );
};

export default AiChatDisclaimer;
